import React from 'react';

/*
 * Fair-housing trust signal. Mirrors the protected grounds actually enforced
 * by the backend guard (backend/src/services/fairHousingLock.js) so this
 * statement never claims more than the system backs up.
 */
const style = {
  margin: '6px auto 0',
  maxWidth: 640,
  fontSize: 10.5,
  lineHeight: 1.5,
  textAlign: 'center',
  color: 'inherit',
  opacity: 0.6,
};

export default function EqualHousingNotice({ className }) {
  return (
    <p className={className} style={className ? undefined : style}>
      This service is committed to fair housing. Every buyer is welcome regardless of race,
      colour, religion, sex, sexual orientation, gender identity, marital or family status,
      disability, or source of income, in accordance with the Canadian Human Rights Act and the
      Newfoundland and Labrador Human Rights Act.
    </p>
  );
}
